<div class="d-flex-center">
    @if (previewMode) {
        <mat-form-field style="margin-right: 10px">
            <mat-label>{{ "general.previewScene" | transloco }}</mat-label>
            @if (selectedScene && currentSceneId != selectedSceneId) {
                <input [readonly]="true" matInput type="text" [value]="selectedScene.Player.$.label" />
            } 
            @if (!selectedScene || currentSceneId == selectedSceneId) {
                <input [readonly]="true" matInput type="text" [value]="currentSceneName" />
            }
        </mat-form-field>
    } @else {
        <mat-form-field style="margin-right: 10px">
            <mat-label>{{ "general.filterAssignedScene" | transloco }}</mat-label>
            <input [readonly]="true" matInput type="text" [value]="selectedScene?.Player?.$?.label" />
            <a matSuffix aria-label="Clear" (click)="resetSelection()">
                <mat-icon>close</mat-icon>
            </a>
        </mat-form-field>
    }
    <button mat-icon-button class="mini-button" matTooltip="{{ 'general.selectScene' | transloco }}" (click)="openSceneAssignmentDialog()">
        <mat-icon>add_circle</mat-icon>
    </button>
    @if (showJump) {
        <button mat-icon-button class="mini-button" matTooltip="{{ 'general.jumpToScene' | transloco }}" (click)="linkToOtherScene()" [disabled]="currentSceneId == selectedSceneId">
            <mat-icon>link</mat-icon>
        </button>
    } 
    
    @if (previewMode) {
        <button mat-icon-button class="mini-button" matTooltip="{{ 'general.reset' | transloco }}" (click)="resetSelection()" [disabled]="currentSceneId == selectedSceneId">
            <mat-icon>restart_alt</mat-icon>
        </button>
    }
</div>
